import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../subcomponents/PageLayout';
import NewsManagementTab from './news/NewsManagementTab';
import InformationManagementTab from './information/InformationManagementTab';

export default function WebManagementPage() {
    const [value, setValue] = useState(0);

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.MANAGEMENT_WEB}
            content={
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label={resourceFinal[appLanguage].words.NEWS} />
                            <Tab label={resourceFinal[appLanguage].words.INFORMATION} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <NewsManagementTab />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <InformationManagementTab />
                    </TabPanel>
                </>
            }
            bottomBar
            fullScreen
        />
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            sx={{ display: value !== index ? 'none' : 'flex', flex: '1 1 auto' }}
        >
            {value === index && (
                <Box sx={{ display: 'flex', flex: '1 1 auto', p: 1 }}>
                    {children}
                </Box>
            )}
        </Box>
    );
};

